import { Avatar, FormHelperText, Grid, Stack } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import CustomButton from '../../elements/CustomButton';
import InputField from '../../elements/InputField';
import { Person } from '@mui/icons-material';

const ExpertAdviceForm = ({ onSubmit, data }) => {
  const userName = /^[A-Za-z][A-Za-z0-9_]{4,20}$/;
  return (
    <Formik
      initialValues={{
        description: data?.description || '',
        name: data?.name || '',
        designation: data?.designation || '',
        tiktokId: data?.tiktok_id || '',
        instagramId: data?.instagram_id || '',
        twitterId: data?.twitter_id || '',
      }}
      validationSchema={Yup.object().shape({
        description: Yup.string().required('Description is required'),
        name: Yup.string()
          .matches(
            /^[\s\S]{1,255}$/,
            'Expert name should not exceed 255 characters'
          )
          .required('Product Name is required'),
        designation: Yup.string().optional(),
        tiktokId: Yup.string().min(4, 'Tiktok username must be atleast 4 characters long').max(20, 'Only 20 charcaters allowed').matches(userName, 'Please enter valid Tiktok username').optional(),
        twitterId: Yup.string().min(4, 'Twitter username must be atleast 4 characters long').max(20, 'Only 20 charcaters allowed').matches(userName, 'Please enter valid Twitter username').optional(),
        instagramId: Yup.string().min(4, 'Instagram username must be atleast 4 characters long').max(20, 'Only 20 charcaters allowed').matches(userName, 'Please enter valid Instagram username').optional(),
      })}
      onSubmit={onSubmit}>
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
        setFieldValue,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <label
                htmlFor="image-upload"
                style={{
                  flex: 3,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}>
                <div>
                  {data?.image || values.image ? (
                    <Avatar
                      src={
                        values.image
                          ? URL.createObjectURL(values.image)
                          : `${data?.image}?w=300&h=300&fit=crop&auto=format`
                      }
                      alt={data?.title}
                      sx={{
                        width: 150,
                        height: 150,
                        marginBottom: '15px',
                      }}
                    />
                  ) : (
                    <Avatar
                      sx={{
                        width: 150,
                        height: 150,
                        marginBottom: '15px',
                      }}>
                      <Person
                        sx={{
                          width: 100,
                          height: 100,
                        }}
                      />
                    </Avatar>
                  )}
                </div>
                <input
                  accept="image/*"
                  id="image-upload"
                  name="image"
                  type="file"
                  onChange={(event) => {
                    const selectedFile = event.currentTarget.files[0];
                    setFieldValue('image', selectedFile);
                  }}
                  style={{ display: 'none' }}
                />
              </label>
            </Grid>

            <Grid item xs={12} md={6}>
              <Stack spacing={1}>
                <InputField
                  label="Name"
                  id="name"
                  type="text"
                  name="name"
                  fullWidth
                  placeholder="Enter name"
                  error={Boolean(touched.name && errors.name)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.name}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={1}>
                <InputField
                  label="Designation"
                  id="designation"
                  type="text"
                  name="designation"
                  fullWidth
                  placeholder="Enter designation"
                  error={Boolean(touched.designation && errors.designation)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.designation}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack spacing={1}>
                <InputField
                  label="Tiktok username"
                  id="tiktokUsername"
                  type="text"
                  name="tiktokId"
                  fullWidth
                  placeholder="Enter TikTok Username"
                  error={Boolean(touched.tiktokId && errors.tiktokId)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.tiktokId}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack spacing={1}>
                <InputField
                  label="Twitter username"
                  id="twitterId"
                  type="text"
                  name="twitterId"
                  fullWidth
                  placeholder="Enter Twitter Username"
                  error={Boolean(touched.twitterId && errors.twitterId)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.twitterId}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack spacing={1}>
                <InputField
                  label="Instagram username"
                  id="instagramId"
                  type="text"
                  name="instagramId"
                  fullWidth
                  placeholder="Enter Instagram Username"
                  error={Boolean(touched.instagramId && errors.instagramId)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.instagramId}
                />
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Stack spacing={1}>
                <InputField
                  label="Description"
                  id="description"
                  type="text"
                  value={values.description}
                  name="description"
                  fullWidth
                  rows={5}
                  multiline
                  placeholder="Enter expert advice"
                  error={Boolean(touched.description && errors.description)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Stack>
            </Grid>

            {errors.submit && (
              <Grid item xs={12}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Grid>
            )}
            <Grid item xs={12}>
              <CustomButton />
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default ExpertAdviceForm;
